<button [class]="'btn btn-primary ' + buttonClass"
        (click)="onClick($event)"
        [disabled]="isDisabled()"
        [ngbTooltip]="tooltip()"
        style="width: 100%">
  @if (leadingIcon()) {
    <i [class]="leadingIcon()"></i>
  }

  {{ title() }}

  @if (trailingIcon()) {
    <i [class]="trailingIcon()"></i>
  }
</button>
